"use client";

import React from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "./ui/card";
import send from "../assets/images/sentCrypto.png";
import { Button } from "./ui/button";
import { SecuredFooter } from "./ui/secured-footer";
import { TransactionDetails } from "./ui/transaction-details";

const SendComplete = ({ assetName, onDone, transactionData }) => {
  const navigate = useNavigate();
  const finalAssetName = assetName?.toUpperCase() || "Asset";

  const handleBackToWallet = () => {
    navigate("/trading/digitalWallet");
    if (onDone) onDone();
  };

  const handleViewHistory = () => {
    navigate("/trading/digitalWallet", {
      state: { openTransactionHistory: true },
    });
    if (onDone) onDone();
  };

  return (
    <>
      <Card className="w-full bg-white rounded-2xl shadow-xl px-12 pt-12 flex flex-col items-center text-center">
        <div className="flex flex-col items-center justify-center max-w-[377px] px-5 min-h-[40vh]">
          <img
            src={send}
            alt="Send Success"
            width={150}
            height={150}
            className="mb-6"
          />

          <h2 className="text-[32px] font-semibold text-[#57249C] mb-4">
            {"You've sent"} {finalAssetName}
          </h2>
          <p className="text-lg font-normal text-[#423E51] mb-6">
            Your crypto is moving safely, just like you planned.
          </p>

          {transactionData && (
            <div className="w-full mb-6">
              <TransactionDetails
                amount={transactionData.amount}
                asset={transactionData.asset || assetName}
                fees={transactionData.fees}
                transactionId={transactionData.transactionId}
                timestamp={transactionData.timestamp || new Date()}
                status={transactionData.status || "complete"}
              />
            </div>
          )}

          <div className="flex flex-col sm:flex-row gap-4 w-full mb-6">
            <Button
              onClick={handleBackToWallet}
              className="flex-1 bg-[linear-gradient(86.72deg,#57249C_-10.66%,#EB3366_113.47%)] text-white px-6 py-4 rounded-full font-semibold hover:opacity-90 transition-opacity h-[48px]"
            >
              Back to Wallet
            </Button>
            <Button
              onClick={handleViewHistory}
              variant="outline"
              className="flex-1 border-2 border-[#57249C] text-[#57249C] px-6 py-4 rounded-full font-semibold hover:bg-purple-50 transition-opacity h-[48px]"
            >
              View Transaction History
            </Button>
          </div>
        </div>

        <SecuredFooter />
      </Card>
    </>
  );
};

export default SendComplete;
